<!-- Backdrop Overlay -->
<div class="pwa-update-backdrop fixed inset-0 z-[9999] transition-all duration-300"
  [class.opacity-0]="!pwaUpdateService.updateAvailable()"
  [class.opacity-100]="pwaUpdateService.updateAvailable()"
  [class.pointer-events-none]="!pwaUpdateService.updateAvailable()"
  [class.pointer-events-auto]="pwaUpdateService.updateAvailable()">
  <div class="absolute inset-0 bg-black/30 backdrop-blur-sm"></div>
</div>

<!-- Update Notification Modal -->
<div class="pwa-update-notification fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-[10000] transition-all duration-500 ease-out"
  [class.scale-0]="!pwaUpdateService.updateAvailable()"
  [class.scale-100]="pwaUpdateService.updateAvailable()"
  [class.opacity-0]="!pwaUpdateService.updateAvailable()"
  [class.opacity-100]="pwaUpdateService.updateAvailable()"
  [class.pointer-events-none]="!pwaUpdateService.updateAvailable()"
  [class.pointer-events-auto]="pwaUpdateService.updateAvailable()">

  <!-- Update Panel Card -->
  <div class="update-panel bg-gradient-to-br from-white via-primary-50 to-secondary-50 rounded-3xl shadow-strong border-2 border-primary-200 max-w-md w-full mx-4 overflow-hidden">

    <!-- Animated Background Pattern -->
    <div class="absolute inset-0 opacity-5">
      <div class="absolute top-0 left-0 w-32 h-32 bg-secondary-400 rounded-full blur-3xl animate-pulse"></div>
      <div class="absolute bottom-0 right-0 w-40 h-40 bg-primary-400 rounded-full blur-3xl animate-pulse" style="animation-delay: 0.5s"></div>
    </div>

    <!-- Content -->
    <div class="relative p-8">

      <!-- Icon -->
      <div class="flex justify-center mb-6">
        <div class="relative">
          <!-- Rotating rings with AgriXe colors -->
          <div class="absolute inset-0 rounded-full border-3 border-primary-300/40 animate-spin-slow"></div>
          <div class="absolute inset-2 rounded-full border-3 border-secondary-300/40 animate-spin-reverse"></div>
          <!-- Icon -->
          <div class="relative bg-gradient-to-br from-primary-100 to-secondary-100 backdrop-blur-md rounded-full p-6 border-2 border-primary-200 shadow-lg">
            <i class="fas fa-download text-5xl text-primary-600 animate-bounce-slow"></i>
          </div>
        </div>
      </div>

      <!-- Title -->
      <h2 class="text-3xl font-brand font-bold text-center mb-3 animate-pulse-slow text-primary-700">
        New Update Available! 🌱
      </h2>

      <!-- Message -->
      <p class="text-center text-neutral-700 mb-8 text-lg leading-relaxed font-body">
        A new version of <strong class="text-primary-600 font-semibold">AgriXe Auctions</strong> is ready with improved features and performance.
      </p>

      <!-- Action Buttons -->
      <div class="space-y-3">
        <button
          (click)="onUpdateClick()"
          class="w-full px-6 py-4 bg-gradient-to-r from-primary-500 to-primary-600 text-white font-bold text-lg rounded-xl hover:from-primary-600 hover:to-primary-700 active:scale-95 transition-all shadow-md hover:shadow-lg flex items-center justify-center gap-3 group">
          <i class="fas fa-download group-hover:translate-y-1 transition-transform duration-300"></i>
          <span>Update Now</span>
          <i class="fas fa-arrow-right group-hover:translate-x-1 transition-transform"></i>
        </button>

        <button
          (click)="onDismissClick()"
          class="w-full px-6 py-3 bg-neutral-100 hover:bg-neutral-200 text-neutral-700 font-semibold rounded-xl transition-all border-2 border-neutral-300 hover:border-neutral-400">
          <i class="fas fa-clock mr-2"></i>Update Later
        </button>
      </div>

      <!-- Additional Info -->
      <p class="text-center text-neutral-500 text-xs mt-6 flex items-center justify-center gap-2">
        <i class="fas fa-info-circle"></i>
        <span>The update will reload the page and take just a moment</span>
      </p>

    </div>

    <!-- Decorative Bottom Bar with AgriXe brand colors -->
    <div class="h-2 bg-gradient-to-r from-primary-300 via-secondary-300 to-primary-400 animate-gradient"></div>
  </div>

</div>
